module.exports = __webpack_public_path__ + "static/media/lekcje-na-odleglosc.60277c1e.jpg";